var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('a',{attrs:{"href":"http://service.wedowick.de/?lang=en#WickSelector","target":"_blank"}},[_vm._v(" Open Wick Configurator ")])])
}]

export { render, staticRenderFns }